"use client";

export { PostBody as ArticleBody, type PostBodyProps as ArticleBodyProps } from "@/views/post/partials/PostBody/PostBody";
